import type { Location } from "../lib/types";

interface Props {
  query: string;
  setQuery: (v: string) => void;
  results: Location[];
  cityLabel?: string;
  onSubmit?: () => void;
}

export function Hero({
  query,
  setQuery,
  results,
  cityLabel = "your area",
  onSubmit,
}: Props) {
  const count = results.length;
  const headlineCount = count >= 100 ? `${Math.round(count / 10) * 10}+` : `${count}+`;

  return (
    <section className="hero-gradient">
      <div className="max-w-page mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-20 text-center">
        <h1 className="hero-headline text-3xl sm:text-4xl md:text-5xl lg:text-[52px] text-slate-900 max-w-3xl mx-auto">
          {headlineCount} MoneyGram locations in {cityLabel}
        </h1>
        <p className="mt-4 text-base md:text-lg text-slate-700 max-w-2xl mx-auto">
          Trusted by millions worldwide. Get great exchange rates, low fees, and
          many ways to send and receive money.
        </p>
        <form
          className="mt-7 max-w-xl mx-auto"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit?.();
          }}
        >
          <div className="hero-search">
            <span className="text-slate-500 text-sm" aria-hidden>
              ⌖
            </span>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Denver, Colorado"
              aria-label="Search location"
            />
            <button type="submit" aria-label="Search">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
